import {css, FormControl, FormControlLabel, Radio, RadioGroup, useTheme} from '@mui/material';
import {RadioProps} from '@mui/material/Radio';
import * as React from 'react';
import {GetStylesFunction} from 'src/js/common/types';

import {DlMuiChipButton} from './DlMuiChipButton';

interface RadioOptions {
  translatedLabel: string;
  value: string;
}

interface OwnProps extends RadioProps {
  handleSave?: () => void;
  options: RadioOptions[];
  selectedValue: string;
  handleDiscard: () => void;
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
}

type Props = OwnProps;

export const DlMuiRadioGroup: React.FC<Props> = (props) => {
  const {handleSave, options, selectedValue, handleDiscard, handleOnChange} = props;

  const theme = useTheme();
  const styles = getStyles({theme});

  const handleOnClickSave = () => {
    if (handleSave) {
      handleSave(/* localValue !== 'CHECKED' */);
    }
  };

  const handleOnClickDiscard = () => {
    handleDiscard();
  };

  return (
    <div css={styles.contentWrapper}>
      <FormControl>
        <RadioGroup data-name={'dl-mui-radio-group--radio-group'} value={selectedValue} onChange={handleOnChange}>
          {options.map((option) => (
            <FormControlLabel
              key={option.translatedLabel}
              value={option.value}
              control={<Radio size={'small'} />}
              label={option.translatedLabel}
            />
          ))}
        </RadioGroup>
      </FormControl>
      <div css={styles.buttonsWrapper}>
        <DlMuiChipButton onClick={handleOnClickDiscard} variant={'outlined'} title={'patient.card.chipButton.discard'} />
        <DlMuiChipButton
          inputCss={styles.filledButton}
          variant={'filled'}
          title={'patient.card.chipButton.save'}
          onClick={handleOnClickSave}
        />
      </div>
    </div>
  );
};

DlMuiRadioGroup.displayName = 'DlMuiRadioGroup';

const getStyles: GetStylesFunction = (options) => ({
  contentWrapper: css`
    display: flex;
    flex-direction: column;
    gap: ${options?.theme?.spacing(2)};
    align-items: center;
  `,
  buttonsWrapper: css`
    display: flex;
    flex-direction: row;
    gap: ${options?.theme?.spacing(3)};
  `,
  filledButton: css({
    'backgroundColor': 'var(--dlTheme-500)',
    'color': `${options?.theme?.palette.custom.white}`,

    '&:hover, &:focus': {
      backgroundColor: 'var(--dlTheme-600)',
      color: `${options?.theme?.palette.custom.white}`,
    },

    '&:active': {
      backgroundColor: 'var(--dlTheme-700)',
      color: `${options?.theme?.palette.custom.white}`,
    },
  }),
});
